import type { KeyValuePair } from "@repo/ui/FormLists/keyValuePairList";

export const keyValuePairsToRecord = (
  pairs: readonly KeyValuePair[],
): Record<string, string> | undefined => {
  const filtered = pairs.filter((p) => p.key.trim() !== "");
  if (filtered.length === 0) return undefined;
  return Object.fromEntries(filtered.map((p) => [p.key.trim(), p.value]));
};

export const recordToKeyValuePairs = (
  record?: Record<string, string>,
): KeyValuePair[] => {
  if (!record) return [];
  return Object.entries(record).map(([key, value]) => ({ key, value }));
};
